<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Çıkış Tarihi</label>
            <v-date-picker v-model="value.ExitDate" placeholder="Çıkış Tarihi"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.EYT">EYT</b-form-checkbox>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.Harmful">Tekrar işe alımı sakıncalıdır.</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    }
}
</script>

<style>

</style>